import { cva } from "cva";

export const navbarMenuItemStyles = cva({
  base: "group w-full max-w-250 flex items-center gap-x-12 rounded-sm focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-content-accent",
});

export const navbarMenuItemContentStyles = cva({
  base: "flex-1 flex flex-col items-start gap-y-2",
});

export const navbarMenuItemLabelStyles = cva({
  base: "text-body-4 font-bold text-content-secondary group-hover:text-content-primary group-focus-visible:text-content-primary transition-colors duration-175 ease-out-quad",
});

export const navbarMenuItemDescriptionStyles = cva({
  base: "text-caption text-ink-500 group-hover:text-content-primary group-focus-visible:text-content-primary transition-colors duration-175 ease-out-quad",
});

export const navbarMenuItemIconStyles = cva({
  base: [
    "w-32 h-32 md:w-56 md:h-56 p-4 flex items-center justify-center [&>*]:w-full [&>*]:h-full [--icon-size:32px] bg-ink-100 text-content-primary rounded-sm",
    "group-hover:text-content-accent group-hover:bg-purple-50 group-focus-visible:text-content-accent group-focus-visible:bg-purple-50 transition-colors duration-175 ease-out-quad",
  ],
});
